import { Drawer, Pagination, Row } from "antd";
import React, { Fragment, useState } from "react";
import SearchFilter from "./filters";
import Product from "./Product";
import styles from "./ProductGrid.module.scss";
import {
  fetchExploreProducts,
  fetchOrganisationProducts,
} from "../../../../api/explore.api";
import { ProductDrawer } from "./ProductDrawer";
import AddProductForm from "./AddProductForm";
import { connect } from "react-redux";
import { OrganisationProduct } from "./OrganisationProduct";
import { ProductFinder } from "./ProductFinder";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const ProductGrid = (props) => {
  const [products, setProducts] = useState(new Array(15).fill(null));
  const [organisationProducts, setOrganisationProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [vendorID, setVendorID] = useState("");
  const [categoryID, setCategoryID] = useState("");
  const [showDrawer, setShowDrawer] = useState(false);
  const [activeProduct, setActiveProduct] = useState(null);
  const [showAddProductDrawer, setShowAddProductDrawer] = useState(false);
  const [viewOrganisationProducts, setViewOrganisationProducts] =
    useState(false);
  //   const history = useNavigate();

  const fetchProducts = async () => {
    setLoading(true);
    const searchParams = {
      fields_to_search: {
        bumpMapPresent: [],
        imageResolution: [],
        ...(vendorID && {
          "variants.vendorName": [vendorID],
        }),
        ...(categoryID && {
          "variants.category.categoryName": [categoryID],
        }),
      },
      pageNumber: page - 1,
      pageSize: 15,
      search: search || "",
      sortBy: [],
    };
    const response = await fetchExploreProducts(searchParams);
    setProducts(response.products);
    setTotalPages(response.total);

    console.log("i-log fetch> fetching products");
    console.log("i-log fetch>", search, vendorID, categoryID, page);

    setLoading(false);
  };

  const getOrgProducts = () => {
    fetchOrganisationProducts({
      organisation: props.settings?.user?.organisation?.organisation_id,
    }).then((res) => {
      setOrganisationProducts(res);
    });
  };

  const onPageChange = (page) => {
    console.log("i-log fetch> page change", page);
    setPage(page);
  };

  React.useEffect(() => {
    fetchProducts();
    getOrgProducts();
  }, []);

  React.useEffect(() => {
    fetchProducts();
  }, [page, vendorID, categoryID]);

  const onSearch = (e) => {
    if (e) e.preventDefault();
    fetchProducts();
  };

  return (
    <Fragment>
      <ProductDrawer product={activeProduct} setProduct={setActiveProduct} />
      <div className="my-2">
        <ProductFinder
          search={search}
          setSearch={setSearch}
          vendorID={vendorID}
          setVendorID={setVendorID}
          categoryID={categoryID}
          setCategoryID={setCategoryID}
          page={page}
          setPage={setPage}
          onSubmit={onSearch}
          viewOrganisationProducts={viewOrganisationProducts}
          setViewOrganisationProducts={setViewOrganisationProducts}
          addProduct={() => setShowAddProductDrawer(true)}
        />
      </div>
      <section className={styles.grid}>
        {viewOrganisationProducts
          ? organisationProducts.map((product) => (
              <OrganisationProduct product={product} key={product.id} />
            ))
          : products &&
            products.map((product, index) => {
              return (
                <Product
                  key={index}
                  loading={loading}
                  product={product}
                  setProduct={setActiveProduct}
                />
              );
            })}
      </section>
      {!viewOrganisationProducts && (
        <section className={styles.paginationContainer}>
          <Pagination
            current={page}
            total={totalPages}
            onChange={onPageChange}
          />
        </section>
      )}
      <Drawer
        visible={showAddProductDrawer}
        onClose={() => setShowAddProductDrawer(false)}
        width={500}
        headerStyle={{ display: "none" }}
      >
        <AddProductForm onClose={() => setShowAddProductDrawer(false)} />
      </Drawer>
    </Fragment>
  );
};

export default connect(mapStateToProps)(ProductGrid);
